/**
 * The directory's domain: the pure rules that decide what a search asks for, how the filters
 * depend on each other and how the results are ordered. It loads no framework, so anything may
 * read it without pulling the screen in.
 */
export { getCancerParamAction, type CancerParamAction } from './cancerParamSync';
export {
  isAnonymousItem,
  isEmptyItem,
  isExpertItem,
  isProductItem,
  isProfileItem,
  orderDirectoryProfiles,
  type DirectoryAnonymousItem,
  type DirectoryEmptyItem,
  type DirectoryExpertItem,
  type DirectoryItem,
  type DirectoryProductItem,
} from './directoryItems';
export {
  chooseCancerType,
  chooseProductType,
  isTreatmentUnresolved,
  reconcileFilters,
  requiredCancerFromLookup,
  settleAgainstCancerTypes,
  type DirectoryFilters,
  type RequiredCancerFor,
} from './filterCoupling';
export { normalizeSearchQuery } from './searchQuery';
